export default "__VITE_ASSET__DMmVnGDw__"